module.exports = __webpack_public_path__ + "static/media/calendar.12c92692.svg";